// Route: /courses/calendar — «Учебный календарь» в новой навигации.
//
// Проекция всех курсов (= учебных планов) на месячную сетку / agenda. Логика
// целиком в существующем компоненте `PlanCalendar` — здесь только тонкий роут
// с тем же URL-state, что и у прежнего `/study-plan/calendar` (тот редиректит
// сюда, поэтому старые ссылки из писем и уведомлений продолжают работать).
//
// URL state:
//   ?plan=<id>&plan=<id2>  — фильтр по курсам
//   ?date=YYYY-MM          — anchor-месяц
//   ?view=month|agenda     — вид

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { Skeleton } from "@studyhub/ui/components/skeleton";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PlanCalendar } from "@/components/study-plan/calendar/plan-calendar";

const searchSchema = z.object({
	plan: z.array(z.string()).optional(),
	date: z
		.string()
		.regex(/^\d{4}-\d{2}$/)
		.optional(),
	view: z.enum(["month", "agenda"]).optional(),
	demo: z.enum(["default", "loading", "empty", "error"]).optional(),
});

export const Route = createFileRoute("/courses/calendar")({
	validateSearch: tolerantSearch(searchSchema),
	component: CoursesCalendarPage,
	pendingComponent: CoursesCalendarPending,
});

function CoursesCalendarPage(): React.ReactElement {
	const search = Route.useSearch();
	// PlanCalendar сам оборачивается в DetailPageContainer (back-link + padding).
	return <PlanCalendar planFilter={search.plan} initialMonth={search.date} view={search.view} />;
}

/** Skeleton повторяет структуру: back-link + шапка + месячная сетка (без layout-shift). */
function CoursesCalendarPending(): React.ReactElement {
	return (
		<div className="min-w-0 px-page-x py-page-y lg:px-page-x-lg">
			<Skeleton className="mb-3 h-8 w-32" />
			<div className="flex flex-col gap-4">
				<div className="flex items-center gap-3">
					<Skeleton className="size-10 rounded-[var(--radius-tile)]" />
					<div className="flex flex-col gap-1.5">
						<Skeleton className="h-5 w-44" />
						<Skeleton className="h-3 w-60" />
					</div>
				</div>
				<Skeleton className="h-[34rem] w-full rounded-[var(--radius-panel)]" />
			</div>
		</div>
	);
}
